<template>
<main class="situation">
  <h1 class="heading-common is-btn-back"><a class="btn-back" @click="back"></a> {{ $t('profile.situation_title') }}</h1>

  <!-- Container -->
  <section class="container" v-show="isLoading">
    <div class="label-learning-box">
      <div class="label-learning">{{ $t('profile.learning_log') }}</div>
      <div class="label-learning-time">
      <span class="color-accent bold">{{ learning_total ? learning_total.learning.h : '' }}</span> {{ $t('profile.learning_log_unit_h') }}
      <span class="color-accent bold">{{ learning_total ? learning_total.learning.m : '' }}</span> {{ $t('profile.learning_log_unit_m') }}
      </div>
    </div>
    <div class="flex-center">
    
      <div class="row">
      <template v-if="sectionList && sectionList.length">
        <ul class="situation-list">
          <li class="box" v-for="(section, section_idx) in sectionList" :key="section_idx" @click="selectSection(section)">
            <div class="title">{{ section.title }}</div>
            <div class="situation-data">
              <div class="situation-status" :class="section.status"></div>
              <div class="situation-progress">
                <div class="progress-label">
                  <div class="label-correct">{{ $t('profile.correct_rate') }}</div>
                  <div class="correct-rate">{{ section.rate  }}%</div>
                </div>
                <div class="progress-bar">
                  <div class="progress-rate" :style="{ width: section.rate + '%' }"></div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </template>
      <template v-else>
        <div class="box" v-show="!isLoading"></div>
      </template>
      </div>
    </div>
  </section>
</main>
</template>

<script>
  import {api} from "../../config";
  import { mapActions, mapGetters, mapState } from 'vuex'

  export default {
    data () {
      return {
        loading: false,
        section_list: [],
        learning_total: {}
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      isLoading () {
        return this.loading
      },
      sectionList() {
         return this.section_list
      },
    },
    
    created() {
      const self = this
      
      self.loading = false
      
      self.learning_total = self.$store.getters.learning_total
      
      let sectionKeys = Object.keys(self.$store.getters.section)
      for(let key of sectionKeys) {
        let sectionData = self.$store.getters.section[key]
        
        let questionAll = self.learning_total.question_all.filter(item => {
            return (item.section_id == sectionData.section_id)
        })
        let correct_count = 0;
        let answer_count = 0;
        
        for(let questionData of questionAll) {
          correct_count += questionData.correct_count;
          answer_count += questionData.answer_count;
        }
        
        let rate = 0;
        if(correct_count && answer_count) {
          rate = Math.round((correct_count / answer_count) * 100);
        }
        this.section_list.push({
          ...sectionData,
          rate: rate
        })

      }
      this.loading = true
      
    },

    mounted() {
      
      const self = this
      
      self.loading = true
    },
    methods: {
      selectSection(section) {
        if(section.status != 'incomplete') {
          this.$router.push({name: 'profile.situation.detail', params: { category: section.section }})
        }
      },
      back() {
        this.$router.push({name: 'profile'})
      }
    },

  }
</script>
